import React, { useRef, useState } from "react"
import tw from "twin.macro"

import { useTranslation } from "next-i18next"
import { Button } from "../formElements/button"

import { Authentication, AuthenticatonPage } from "../authentication"
import { Modal } from "../modal"
import Link from "next/link"
import { ReactComponent as Unmute } from "../../assets/homepage/unmute.svg"
import { ReactComponent as Mute } from "../../assets/homepage/mute.svg"
import { ReactComponent as ArtistPlatforms } from "../../assets/homepage/artistPlatforms.svg"
import { ReactComponent as RankSuperfans } from "../../assets/homepage/rankSuperfans.svg"
import { ReactComponent as SpreadTheLove } from "../../assets/homepage/spreadTheLove.svg"
import { ReactComponent as Felix } from "../../assets/homepage/felix.svg"

export const Homepage = () => {
  const { t } = useTranslation("homepage")
  const [isMuted, setIsMuted] = useState(true)
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [view, setView] = useState(AuthenticatonPage.Join)
  const [show, setShow] = useState(false)
  const [isNotDismissable, setIsNotDismissable] = useState(false)

  const vidRef = useRef<HTMLVideoElement>(null)
  const modalProps = {
    show,
    setShow,
    notDismissable: isNotDismissable,
    component: <Authentication view={view} setShow={setShow} setNotDismissable={setIsNotDismissable} />,
  }
  return (
    <div tw="bg-base-6 text-white pt-5 tablet-lg:space-y-6">
      <section tw="flex items-center justify-center flex-col tablet-lg:flex-row">
        {/* Left side content container */}
        <div tw="w-full tablet-lg:w-1/2">
          {/* Title */}
          <div tw="order-1 tablet-lg:order-none">
            <h1 tw="text-2xl font-bold tablet-lg:text-4xl pb-4 text-center tablet-lg:text-left">
              {t("identify_engage_monetize")}
            </h1>
          </div>

          {/* Description and button - shows after video on mobile, stays under title on desktop */}
          <div tw="order-3 tablet-lg:order-none">
            <p tw="px-5 text-lg font-bold pb-5 text-center tablet-lg:(text-2xl px-0) tablet-lg:font-normal  tablet-lg:text-left">
              {t("platform_description")}
            </p>
            <div tw="w-1/2 mx-auto py-4 items-center tablet-lg:(w-60 mx-0)">
              <Link prefetch={false} passHref href="mailto:jake@joinbonsai.co">
                <a>
                  <Button twStyle={tw`w-full p-3`} action={t("request_demo")} />
                </a>
              </Link>
            </div>
          </div>
        </div>

        {/* Video section - shows between title and description on mobile, stays on right in desktop */}
        <div tw="order-2 tablet-lg:order-none relative w-[297px] h-[528px] tablet-lg:(w-[393px] h-[698px])">
          <video
            id="vid"
            controls={false}
            loop
            autoPlay
            muted={isMuted}
            src="https://bonsai-media.s3.amazonaws.com/what-is-bonsai.mp4"
            preload="metadata"
            ref={vidRef}
            playsInline
          >
            <source src="https://bonsai-media.s3.amazonaws.com/what-is-bonsai.mp4" type="video/mp4" />
          </video>
          <span tw="m-5 absolute left-0 bottom-[20px] cursor-pointer" onClick={() => setIsMuted(!isMuted)}>
            {isMuted ? <Mute /> : <Unmute />}
          </span>
        </div>
      </section>

      {/* Artist social media Section */}
      <section tw="container mx-auto px-5 py-12 tablet-lg:py-16">
        <div tw="flex flex-col items-center max-w-6xl mx-auto tablet-lg:(flex-row items-center) gap-16">
          <div tw="w-full max-w-xl tablet-lg:w-1/2">
            <ArtistPlatforms width="100%" height="100%" />
          </div>
          <div tw="space-y-6 flex-1 text-center tablet-lg:text-left">
            <h2 tw="text-2xl tablet-lg:text-3xl font-bold">{t("add_artist_roster")}</h2>
            <p tw="text-lg">{t("connect_accounts")}</p>
          </div>
        </div>
      </section>

      {/* Fan Data Section */}
      <section tw="container mx-auto px-5 py-12 tablet-lg:py-16">
        <div tw="flex flex-col tablet-lg:(flex-row items-center) gap-16">
          <div tw="space-y-6 flex-1 tablet-lg:order-1 order-2">
            <h2 tw="text-2xl tablet-lg:text-3xl font-bold">{t("rank_and_reward")}</h2>
            <p tw="text-lg">{t("bonus_dedication")}</p>
          </div>
          <RankSuperfans tw="w-full tablet-lg:w-1/2 h-auto order-1 tablet-lg:order-2" />
        </div>
      </section>

      {/* Platform Distribution Section */}
      <section tw="container mx-auto px-5 py-12 tablet-lg:py-16">
        <div tw="flex flex-col tablet-lg:(flex-row items-center) gap-16">
          <div tw="flex items-center justify-center flex-1 ">
            <SpreadTheLove tw="w-full tablet-lg:w-3/4 h-auto" />
          </div>
          <div tw="space-y-6 flex-1">
            <h2 tw="text-2xl tablet-lg:text-3xl font-bold">{t("spread_fan_love")}</h2>
            <p tw="text-lg">{t("respond_to_interactions")}</p>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section tw="flex items-center justify-end flex-wrap tablet-lg:(flex-nowrap)">
        <div tw="self-center w-full py-10 px-5 space-y-5 tablet-lg:(w-1/2 space-y-10)">
          <h1 tw="text-4xl mb-5 font-bold tablet-lg:text-3xl">{t("want_to_see")}</h1>
          <Link prefetch={false} passHref href="mailto:jake@joinbonsai.co">
            <a>
              <Button tw="mt-10" action={t("request_demo")} />
            </a>
          </Link>
        </div>
        <Felix tw="h-auto" />
      </section>
      <Modal {...modalProps} />
    </div>
  )
}
